import thumbnail1 from '../../assets/images/achievements/1.webp';
import thumbnail2 from '../../assets/images/achievements/2.webp';
import thumbnail3 from '../../assets/images/achievements/3.webp';
import thumbnail4 from '../../assets/images/achievements/4.webp';
import thumbnail5 from '../../assets/images/achievements/5.webp';
import thumbnail6 from '../../assets/images/achievements/6.webp';


const response =  {
    "status": 200,
    "message": "OK",
    "data": [
        {
            "id": 1,
            "thumbnail": thumbnail1,
            "title": "Dicoding - MPWA/Frontend Facilitator Certificate",
        },
        {
            "id": 2,
            "thumbnail": thumbnail2,
            "title": "Dicoding - Backend Facilitator Certificate",
        },
        {
            "id": 3,
            "thumbnail": thumbnail3,
            "title": "Dicoding - MPWA/Frontend Completion Certificate",
        },
        {
            "id": 4,
            "thumbnail": thumbnail4,
            "title": "PT. Solusi Intek Indonesia - Internship Completion Certificate",
        },
        {
            "id": 5,
            "thumbnail": thumbnail5,
            "title": "Progate - Node.js Path Completion Certificate",
        },
        {
            "id": 6,
            "thumbnail": thumbnail6,
            "title": "Ready Set Code Kominfo - SQL Path Completion Certificate",
        },
    ]
}

export default response;